module.exports = __webpack_public_path__ + "img/literature.db28d863.jpg";